
import { formatNumber } from "@/static/utils";
import { Loan, LoanStatus } from "@/models/Loan";
export default {
  name: "list-loan",
  props: {
    loanData: Object,
  },
  setup(props, context) {
    const handleLoanClick = (loan: Loan) => {
      context.emit("loanClick", loan);
    };
    return { formatNumber, handleLoanClick, LoanStatus };
  },
};
